import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Notices } from '../../../../../core/entities/notices.model';
import { Texts } from 'src/app/core/entities/texts.model';
import { MatDialog } from '@angular/material/dialog';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';
import { EditDialogsNoticesComponent } from './dialogs-notices/edit-dialogs-notices/edit-dialogs-notices.component';
import { EditDialogsTextsComponent } from '../texts/dialogs-texts/edit-dialogs-texts/edit-dialogs-texts.component';

@Component({
  selector: 'app-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.scss']
})
export class NoticesComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  notice: Notices = new Notices();

  mensajeError: boolean = false;

  constructor(private internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) { 
      super();
    }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllNotices();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla notices
  */
  private getAllNotices(): void {
    this.loading = true;
    this.internalHomeService.allNotices().subscribe(res => {
      console.log(res);
      this.loading = false;
    }, error => {
      this.mensajeError = true;
      this.loading = false;
      this.showMsg(error);
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un notice
  * @param parametro Opcional. Notice vacio.
  */
  public createNotice(notice?: Notices) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    notice = this.notice;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsNoticesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { notice, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllNotices();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un notice
  */
  public editNotice(notice?: Notices) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsNoticesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { notice, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllNotices();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un notice
  * @param text Notice a eliminar
  */
  public removeNotice(notice?: Notices) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_texts') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeNotices(notice).subscribe(res => {
          console.log(res);
          this.getAllNotices();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }


  public editTextos(text: Texts){
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    console.log(text);
    const dialogRef = this.dialog.open(EditDialogsTextsComponent, {
      width: '70%',
      disableClose: true,
      hasBackdrop: true,
      data: { text, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllNotices();
      }, 1000);
    });
  }

}
